/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Dropdown from 'react-bootstrap/Dropdown'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
// import { useSelector } from "react-redux";
import ArNav from "./navigation/ArNav";
import WipNav from "./navigation/WipNav";
// import BillNav from "./navigation/BillNav";
import HrNav from "./navigation/HrNav";
import PowerBINav from "./navigation/PowerBINav";
import NCTONav from './navigation/NCTONav'
import 'primeicons/primeicons.css';
import { HelpMarker } from "./Help";
/**
 * Renders the navbar component with a sign in or sign out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = ({ setShowHelp, children }) => {

    return (
        <>
            <Navbar expand='lg' variant="dark" className="navbarStyle primary-bg brand-text brand-gradient">
                <Container>
                    <Navbar.Brand href="/">
                        <img
                            src="/Magnify-21.png"
                            width="130px"
                            alt="Magnify logo on blue and white background, representing a brand with a sleek and modern design."
                        // height="10px"
                        />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav>
                            <Nav.Link href="/" className="brand-text">Home</Nav.Link>
                            <Dropdown variant="primary-bg brand-text">
                                <Dropdown.Toggle variant="primary-bg brand-text">
                                    Magnify Reports
                                </Dropdown.Toggle>
                                <Dropdown.Menu >
                                    <ArNav />
                                    <WipNav />
                                    {/* <BillNav /> */}
                                    {/* <HrNav /> */}
                                    <PowerBINav />
                                </Dropdown.Menu>
                            </Dropdown>
                            <Dropdown>
                                <Dropdown.Toggle variant="primary-bg brand-text">
                                    Magnify People
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item href="/people/reviews">Reviews</Dropdown.Item>
                                    <Dropdown.Item href="/people/morale">Morale</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            <Dropdown>
                                <Dropdown.Toggle variant="primary-bg brand-text">
                                    Magnify Clients
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <NCTONav />
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>
                        <HelpMarker
                            className={"help-button"}
                            icon="pi-question"
                            showCallBack={() => setShowHelp(true)}
                        >
                            <span>Help</span>
                        </HelpMarker>
                    </Navbar.Collapse>
                </Container>

            </Navbar>
            {children}
        </>
    )
};